<!--右下角商店信息-->
<template>
	<div class="flexBetween">
		<div>
			<p class="shopBigTitle">电器商城</p>
			<p>品牌总类</p>
			<div class="hideBar custom-scrollbar listBoxDiv">
				<p v-for="item in brandList">{{item}}</p>
			</div>
			<p class="shopBigTitle">供应链金融</p>
			<p class="orgText">{{shouldReceivePayment}}</p>
			<p class="littleTitle">应收账款融资</p>
		</div>
		<div>
			<p style="margin-top: 15px;" class="littleTitle">订单量: <span>{{shopOrderCount}}</span> </p>
			<p>商品总类</p>
			<div class="hideBar custom-scrollbar listBoxDiv">
				<p v-for="item in commodityList">{{item}}</p>
			</div>
			<p class="littleTitle">订单数: <span>{{supplyOrderCount}}</span> </p>
			<p class="orgText">{{inventory}}</p>
			<p class="littleTitle">库存融资</p>
		</div>
		<div>
			<p style="margin-top: 15px;" class="littleTitle">交易额: <span>{{shopOrderMoneyCount}}</span> </p>
			<p>自营店</p>
			<div class="hideBar custom-scrollbar listBoxDiv">
				<p v-for="item in commodityList">{{item}}</p>
			</div>
			<p class="littleTitle">融资金额: <span>{{supplyOrderMoneyCount}}</span> </p>
			<p class="orgText">{{prepayments}}</p>
			<p class="littleTitle">库存融资</p>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				"shopOrderCount": 0,
				"shopOrderMoneyCount": 0,
				"brandList": [],
				"commodityList": [],
				"shopList": [],
				"supplyOrderCount": 0,
				"supplyOrderMoneyCount": 0,
				"shouldReceivePayment": 555,
				"inventory": 0,
				"prepayments": 0
			}
		},
		created() {},
		mounted() {
			var axios = require('axios')
			axios({
				url: "/static/中科泛在定制/看板/数据/info.json",
			}).then(respon => {
				var data = JSON.parse(JSON.stringify(respon.data))
				eachObject(data.onlineShop, (value, key) => {
					this[key] = value
				})
			})
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.onlineShop>div {
		width: 32%;
		height: 100%;
		overflow: hidden;
		margin: 0 15px;
	}

	.onlineShop p,
	.onlineShop span {
		color: white;
		text-align: center;
	}

	.onlineShop p {
		margin: 13px 0 0 0;
	}

	.listBoxDiv {
		height: 60px;
		width: 100%;
	}
	.listBoxDiv>p{
		margin: 7px 0;
	}

	p.shopBigTitle {
		font-size: 18px;
		font-weight: 500;
		color: rgba(0, 198, 255, 1);
		text-align: left;
	}

	p.littleTitle {
		color: #80BFEC;
		font-weight: 500;
	}
	p.littleTitle>span{
		font-size: 18px;
	}
	p.orgText{
		color: #FFA657;
		font-size: 18px;
		font-weight: bold;
	}
</style>
